import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/hooks';
import FormField from './FormField';
const UserNameField = ({ errors, value, onInput }) => {
    const handleFirstNameInput = useCallback((_, value) => {
        onInput("firstName", value);
    }, []);
    const handleLastNameInput = useCallback((_, value) => {
        onInput("lastName", value);
    }, []);
    return (_jsxs("div", Object.assign({ className: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u304A\u540D\u524D" }), void 0),
            _jsxs("div", Object.assign({ className: "field-body" }, { children: [_jsx(FormField, { value: value, fieldName: "firstName", label: "", onInput: handleFirstNameInput, placeHolder: "\u5C71\u7530", inputType: "text", errors: errors }, void 0),
                    _jsx(FormField, { value: value, fieldName: "lastName", label: "", onInput: handleLastNameInput, placeHolder: "\u592A\u90CE", inputType: "text", errors: errors }, void 0)] }), void 0)] }), void 0));
};
export default UserNameField;
